// extracted by mini-css-extract-plugin
export default {"MediaMatchInfoBlock":"MediaMatchInfoBlock--VlSbx","text":"text--Agn97","link":"link--pR90O"};